<template>
	<div name="hres75u-popup-approve" id="hres75u-popup-approve" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">
	    <div class="modal-content">
	      <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal" ref="popupApproveModalButton">&times;</button>
          <h4 class="modal-title">{{ labels['HRES75UC2']['0'] }}</h4>
        </div>
        <div class="modal-body detail detail-responsive">
        	<div class="detail detail-responsive">
        		<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES75UC2']['10'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="coddesc_codempid" name="desc_codempid">{{ approve.codempid }} - {{ approve.desc_codempid }}</div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES75UC2']['20'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="approvno" name="approvno">{{ approve.approvno }}</div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES75UC2']['30'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="coddesc_codappr" name="desc_codappr">{{ approve.codappr }} - {{ approve.desc_codappr }}</div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES75UC2']['40'] }}</div>
						  <div class="detail-right">
					      <div class="input-group  width-70">
                  <hrms-datepicker  v-model="currentDate"
                                    v-show="false"
                                    v-validate="'required|date_format:DD/MM/YYYY'"
                                    data-vv-value-path="inputDate"
                                    name="currentDate"
                                    :has-error="errors.has('currentDate')" />

                  <hrms-datepicker  v-model="approve.dteappr"
                                    v-validate="'required|date_format:DD/MM/YYYY|after:currentDate'"
                                    data-vv-value-path="inputDate"
                                    name="dteappr"
                                    :has-error="errors.has('dteappr')" />
                	<div class="text-error" v-show="errors.has('dteappr')">{{errors.first('dteappr')}}</div>
					      </div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES75UC2']['50'] }}</div>
						  <div class="detail-right">
						    <div class="input-group  width-70">
						      <input type="text" class="form-control input-text" id="amtwidrw" name="amtwidrw" v-model="approve.amtwidrw" v-validate="{ rules: { required: true, regex: regex.currency } }" :class="{ 'input-error' : errors.has('amtwidrw') }" />
                  <div class="input-group-addon input-group-addon-cust">{{ approve.desc_codunit }}</div>
						  	</div>
                <div v-show="errors.has('amtwidrw')" class="text-error">{{ errors.first('amtwidrw') }}</div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES75UC2']['70'] }}</div>
						  <div class="detail-right">
						      <div class="input-group  width-70">
						        <hrms-datepicker  v-model="approve.dtepay"
			                                v-validate="'required|date_format:DD/MM/YYYY|after:dteappr'"
			                                data-vv-value-path="inputDate"
			                                name="dtepay"
			                                :has-error="errors.has('dtepay')" />
                		<div class="text-error" v-show="errors.has('dtepay')">{{errors.first('dtepay')}}</div>
						      </div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES75UC2']['80'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="numvcher" name="numvcher">{{ approve.numvcher }}</div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES75UC2']['90'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="status" name="status">{{ approve.status }}</div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES75UC2']['130'] }}</div>
						  <div class="detail-right">
						      <textarea class="textarea-text  width-70"
                            maxlength="500"
                            id="remark"
                            name="remark"
                            v-validate="'max:500'"
                            data-vv-name="remark"
                            :has-error="errors.has('remark')"
                            v-model="approve.remark" />
                  <div class="text-error" v-show="errors.has('remark')">{{ errors.first('remark') }}</div>
                  <div class="remark-limit-character">{{ dispLimitLabel(500) }}</div>
						  </div>
						</div>
        	</div>
        </div>

        <div class="modal-footer align-center border-color-skin">
        	<button type="button" class="btn bg-green" @click="validatePopupApprove()" ><i class="fa fa-check-circle"></i> {{ labelsButton['approve'] }}</button>
        </div>

	    </div>
    </div>
	</div>
</template>

<script>
import moment from 'moment'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres75u-popup-approve',
  data () {
    return {
      regex: require('assets/js/regex'),
      approve: {
        codempid: '',
        desc_codempid: '',
        approvno: 0,
        codappr: '',
        desc_codappr: '',
        dteappr: '',
        amtwidrw: '',
        desc_codunit: '',
        dtepay: '',
        numvcher: '',
        staappr: '',
        flgStaappr: '',
        status: '',
        remark: '',
        chk_appr: '',
        numseq: '',
        dtereq: ''
      },
      currentDate: moment().format('DD/MM/YYYY')
    }
  },
  watch: {
    detailSubmit () {
      this.approve = {
        codempid: this.indexSelected.codempid,
        desc_codempid: this.indexSelected.desc_codempid,
        approvno: this.indexSelected.approvno,
        codappr: this.codappr,
        desc_codappr: this.descCodappr,
        dteappr: moment().format('DD/MM/YYYY'),
        amtwidrw: this.detailSubmit.amtwidrw,
        desc_codunit: this.indexSelected.desc_codunit,
        dtepay: this.detailSubmit.dtepay,
        numvcher: this.detailSubmit.numvcher,
        staappr: this.indexSelected.staappr,
        flgStaappr: this.indexSelected.flgStaappr,
        status: this.indexSelected.status,
        remark: '',
        chk_appr: this.indexSelected.chk_appr,
        numseq: this.indexSelected.numseq,
        dtereq: this.indexSelected.dtereq
      }
      this.$nextTick(function () {
        this.errors.clear()
      })
    }
  },
  props: [ 'labels', 'postHres75uSendApprove', 'indexSelected', 'codappr', 'descCodappr', 'labelsButton', 'detailSubmit', 'receivedHres75uDetailSubmit' ],
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    validatePopupApprove () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHres75uSendApprove(this.sendApprove())
        }
      })
    },
    sendApprove () {
      return {
        approveParams: this.approve,
        referenceButton: this.$refs.popupApproveModalButton
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// popupApprove.vue?dc306f92